<div [ngClass]="['periodoTeste', 'link-video']" *ngIf="validacaoCorretora?.periodoTeste && (validacaoCorretora?.prazoHoras >= 0 && (validacaoCorretora?.formaPagamento == 'PIX' || !validacaoCorretora?.formaPagamento) || validacaoCorretora?.prazoHoras >= 24 && validacaoCorretora?.formaPagamento == 'CREDITO') && autenticado && isAdmin && platformService.virtualDeviceType === 'desktop' && showAlert && !isRoot; else elseBlock"> 
    <span class="periodoTeste__text" [ngStyle]="{'margin-left': 'auto', 'font-weight': '500'}" 
    [ngClass]="[rotaAtual === '/contratar' ? 'text-contratacao' : '']">Período de teste restante: {{validacaoCorretora ? 
        validacaoCorretora.prazo == 1 ?  validacaoCorretora.prazo + " dia" :
        validacaoCorretora.prazo == 0 ? "Último dia!" : 
        validacaoCorretora.prazo + " dias" : ''}}</span>        
    <button mat-button class="periodoTeste__contratar" (click)="contratar()" [ngStyle]="{'margin-left': '8px'}" *ngIf="rotaAtual !== '/contratar'"><span>CONTRATAR AGORA</span></button>
    <link-video class="periodoTeste__video" #link toolTip="Bem vindo(a) ao Ápice!" (click)="link.open('intro')"></link-video>

    <button mat-icon-button (click)="esconderPeriodo()" [ngStyle]="{'margin-left': 'auto'}">
        <mat-icon [svgIcon]="'close'" style="color: var(--primary) !important"></mat-icon>
    </button>
</div>
<div [ngClass]="['periodoTeste', 'link-video']" *ngIf="validacaoCorretora?.periodoTeste && (validacaoCorretora?.prazoHoras < 0 && (validacaoCorretora?.formaPagamento == 'PIX' || !validacaoCorretora?.formaPagamento) || validacaoCorretora?.prazoHoras < 24 && validacaoCorretora?.formaPagamento == 'CREDITO') && autenticado && isAdmin && platformService.virtualDeviceType === 'desktop' && showAlert && !isRoot"> 
    <span class="periodoTeste__text" [ngStyle]="{'margin-left': 'auto', 'font-weight': '500'}" 
    [ngClass]="[rotaAtual === '/contratar' ? 'text-contratacao' : '']">Período de teste encerrado!</span>        
    <button mat-button class="periodoTeste__contratar" (click)="contratar()" [ngStyle]="{'margin-left': '8px'}" *ngIf="rotaAtual !== '/contratar'"><span>CONTRATAR AGORA</span></button>
    <link-video class="periodoTeste__video" #link toolTip="Bem vindo(a) ao Ápice!" (click)="link.open('intro')"></link-video>

    <button mat-icon-button (click)="esconderPeriodo()" [ngStyle]="{'margin-left': 'auto'}">
        <mat-icon [svgIcon]="'close'" [ngStyle]="{'color': 'var(--primary)'}"></mat-icon>
    </button>
</div>


    <!-- <div [ngClass]="['periodoTeste']" *ngIf="!validacaoCorretora?.periodoTeste && (validacaoCorretora?.prazoHoras >= 1 && validacaoCorretora?.formaPagamento == 'PIX' || validacaoCorretora?.prazoHoras >= 25 && validacaoCorretora?.formaPagamento == 'CREDITO') && validacaoCorretora?.prazo <= controllerStatus.diasMostrarAlertaRenovacaoAntecipada && autenticado && isAdmin && showAlert"> 
        <span class="periodoTeste__text" [ngStyle]="{'margin-left': 'auto', 'font-weight': '500'}"
         [ngClass]="[rotaAtual === '/contratar' ? 'text-contratacao' : '']">
         {{validacaoCorretora ? 
            validacaoCorretora.prazo > 1 ? "Contrato expira em: " + validacaoCorretora.prazo + " dias" :
            validacaoCorretora.prazo == 1 ? "Contrato expira em: " + validacaoCorretora.prazo + " dia" :
            validacaoCorretora.prazo == 0 ? "Contrato expira hoje!" : 
            "Contrato expirado!" : ''}}
        </span> 
    
        <button mat-button class="periodoTeste__contratar" (click)="verPix()" [ngStyle]="{'margin-left': '8px'}" *ngIf="rotaAtual !== '/contratar' && !controllerStatus.renovacaoManual"><span>RENOVAR AGORA</span></button>
        <button mat-button class="periodoTeste__contratar" (click)="verPix()" [ngStyle]="{'margin-left': '8px'}" *ngIf="rotaAtual !== '/contratar' && controllerStatus.renovacaoManual && controllerStatus.formaPagamento == 'PIX'"><span>VER CÓDIGO PIX DA RENOVAÇÃO</span></button>
    
        <button mat-icon-button (click)="esconderPeriodo()" [ngStyle]="{'margin-left': 'auto'}">
            <mat-icon [svgIcon]="'close'" style="color: var(--primary) !important"></mat-icon>
        </button>
    </div> -->

    <div [ngClass]="['periodoTeste']" *ngIf="!validacaoCorretora?.periodoTeste && validacaoCorretora?.prazoHoras <= 0 && autenticado && isAdmin && showAlert"> 
        <span class="periodoTeste__text" [ngStyle]="{'margin-left': 'auto', 'font-weight': '500'}"
         [ngClass]="[rotaAtual === '/contratar' ? 'text-contratacao' : '']">
            "Contrato expirado!"
        </span> 
        <button mat-icon-button (click)="esconderPeriodo()" [ngStyle]="{'margin-left': 'auto'}">
            <mat-icon [svgIcon]="'close'" [ngStyle]="{'color':'var(--primary)'}"></mat-icon>
        </button>
    </div>

<ng-template #elseBlock>
    <div [ngClass]="['periodoTeste']" *ngIf="validacaoCorretora?.periodoLimitado && autenticado && isAdmin && showAlert"> 
        <span class="periodoTeste__text" [ngStyle]="{'margin-left': 'auto', 'font-weight': '500'}"
         [ngClass]="[rotaAtual === '/contratar' ? 'text-contratacao' : '']">
            Seu período de teste acabou.
        </span> 
    
        <button mat-button class="periodoTeste__contratar" (click)="contratar()" [ngStyle]="{'margin-left': '8px'}" *ngIf="rotaAtual !== '/contratar'"><span>CONTRATAR AGORA</span></button>
    
        <button mat-icon-button (click)="esconderPeriodo()" [ngStyle]="{'margin-left': 'auto'}">
            <mat-icon [svgIcon]="'close'" style="color: var(--primary) !important"></mat-icon>
        </button>
    </div>
</ng-template>

<div
    class="app"
    [ngStyle]="{'height': ((validacaoCorretora?.periodoTeste || validacaoCorretora?.periodoLimitado) && mostraPeriodoTeste) ? 'calc(100% - 40px)' : '100%'}"
    (window:resize)="platformService.onResize($event)">
    <input
        class="extensao"
        type="text"
        id="bExtensaoExterno"
        tabindex="-1">

    <div *ngIf="autenticado" [ngClass]="['menuSide']">
        <mat-toolbar>
            <mat-toolbar-row>
                <img
                [ngClass]="[menuContraido && platformService.virtualDeviceType == 'desktop' ? 'hiddenLogo' : 'showLogo' ]"
                src="../assets/logos/apice-horizontal-nova-identidade.png"
                (click)="goToCotacoes()">

                <!-- START botão de "Nova Cotação" -->
                 <ng-container *ngIf="menusCotacao.length > 0 && platformService.size.width > 991">
                     <app-menu-nova-cotacao [menusCotacao]="menusCotacao"></app-menu-nova-cotacao>
                 </ng-container>

                <!-- END botão de "Nova Cotação" -->

                <div *ngFor="let item of menuPrincipal ; let i = index">
                    <div class="container-menu" *ngIf="item.subList.length > 0 && !item.justMobile && (item?.justRoot ? isRoot : true) && !escondeIconesMenu">
                        <button #buttonMenu mat-menu-item (click)="rotaLinkMenu(item.url, i)"
                        class="btn-menu" [ngClass]="item.active ? 'activeSubMenu' : ''" [matMenuTriggerFor]="levelOne" #levelOneTrigger="matMenuTrigger"
                        (mouseenter)="buttonEnter(levelOneTrigger)" (mouseleave)="buttonLeave(levelOneTrigger, buttonMenu)">
                            <mat-icon
                                mat-list-icon
                                [svgIcon]="item.icone"
                                [matTooltip]="item.titulo"
                                [matTooltipDisabled]="!recolheItensMenu">
                            </mat-icon>
                            <span class="span-btn-menu" *ngIf="!recolheItensMenu">{{ item.titulo }}</span>
                        </button>
                        <mat-menu #levelOne="matMenu" direction="down" yPosition="below" [hasBackdrop]="false" class="sub-menu">
                            <div class="container-sub-menu" (mouseenter)="menuEnter()" (mouseleave)="menuLeave(levelOneTrigger, buttonMenu)">
                                <span *ngFor="let sub of item.subList; let j = index" class="span-sub-menu" (mouseover)="changeStyle(sub)" (mouseout)="changeStyle(sub)">
                                    <button mat-menu-item (click)="rotaLinkMenu(sub.url, i, j)" *ngIf="sub?.justAdmin ? isAdmin : true" [ngClass]="sub.hovered ? 'hover-open':'not-hovered'">
                                        <mat-icon
                                            mat-list-icon
                                            [svgIcon]="sub.icone">
                                        </mat-icon>
                                        {{ sub.titulo }}
                                    </button>
                                </span>
                            </div>
                        </mat-menu>
                    </div>
                    <div class="container-menu" *ngIf="item.subList.length === 0 && !item.justMobile && (item?.justRoot ? isRoot : true) && !escondeIconesMenu">
                        <button #buttonMenu mat-menu-item (click)="rotaLinkMenu(item.url, i)"
                        class="btn-menu" [ngClass]="item.active ? 'activeSubMenu' : ''">
                            <mat-icon
                                mat-list-icon
                                [svgIcon]="item.icone"
                                [matTooltip]="item.titulo"
                                [matTooltipDisabled]="!recolheItensMenu">
                            </mat-icon>
                            <span class="span-btn-menu" *ngIf="!recolheItensMenu">{{ item.titulo }}</span>
                        </button>
                    </div>
                </div>
                
                <tool-bar-actions
                    #toolBarActions
                    [ngStyle]="{'width':'100%'}"
                    [filtro]="toolBarActionsConfigs[rotaAtual]?.filtro"
                    [showSearch]="toolBarActionsConfigs[rotaAtual]?.busca"
                    [placeholder]="toolBarActionsConfigs[rotaAtual]?.placeholder">
                </tool-bar-actions>
            </mat-toolbar-row>
        </mat-toolbar>

    </div>

    <div *ngIf="autenticado && platformService.virtualDeviceType !== 'desktop'" class="container-tool-bar-mobile">
        <div class="container-titulo-logo" [ngClass]="recolheItensMenu ? 'container-titulo-logo__open' : ''">
            <img src="../assets/logos/apice-vertical-2-nova-identidade.png" class="logo" (click)="goToCotacoes()">
            <span class="subtitle-small">
                {{ toolBarActionsConfigs[rotaAtual]?.titulo ? toolBarActionsConfigs[rotaAtual]?.titulo : encontraTitulo() }}</span>
        </div>
        <div class="container-actions">
            <tool-bar-actions
                class="tool-bar-actions"
                #toolBarActions
                [filtro]="toolBarActionsConfigs[rotaAtual]?.filtro"
                [showSearch]="toolBarActionsConfigs[rotaAtual]?.busca"
                [placeholder]="toolBarActionsConfigs[rotaAtual]?.placeholder">
            </tool-bar-actions>
            <menu-hamburger></menu-hamburger>
        </div>
    </div>

    <div class="container-menu-hamburguer-mobile" *ngIf="autenticado && platformService.virtualDeviceType !== 'desktop'" 
        [ngClass]="[menuToggle ? 'container-menu-hamburguer-mobile__open' : '']">
        <div class="container-menus">
            <div class="container-menu" *ngFor="let item of menuPrincipal ; let i = index">
                <button mat-menu-item (click)="rotaLinkMenu(item.url, i);toggleSubMenu(i)" class="btn-menu" [ngClass]="item.active ? 'activeSubMenu' : ''"  *ngIf="item?.justRoot ? isRoot : true">
                    <div class="container-geral-btn-menu">
                        <div class="container-nome-icone">
                            <mat-icon mat-list-icon [svgIcon]="item.icone">
                            </mat-icon>
                            <span class="span-btn-menu">{{ item.titulo }}</span>
                        </div>
                        <div class="container-icone-expandir" *ngIf="item.subList.length > 0">
                            <mat-icon mat-list-icon [svgIcon]="'chevron-down'" [@animationRotate]="item.open ? 'open' : 'close'"></mat-icon>
                        </div>
                    </div>
                </button>
                <div class="container-sub-menus" [@animationShowHide]="item.open ? 'open' : 'close'" *ngIf="item.subList.length > 0"
                    [ngClass]="i === 0 ? 'first' : ''">
                    <div class="container-sub-menu" *ngFor="let sub of item.subList; let j = index">
                        <button mat-menu-item (click)="rotaLinkMenu(sub.url, i, j)" class="btn-menu" *ngIf="sub?.justAdmin ? isAdmin : true">
                            <div class="container-geral-btn-menu">
                                <div class="container-nome-icone">
                                    <mat-icon mat-list-icon [svgIcon]="sub.icone">
                                    </mat-icon>
                                    <span class="span-btn-menu">{{ sub.titulo }}</span>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-perfil">
            <div (click)="abrirPerfil()" class="container-perfil-content">
                <div class="container-img">
                    <img [src]="apiS3.avatarUsuarioLogado" onError="this.src='assets/img/usuarioAnonimo.png';" [title]="''">
                </div>
                <div class="container-nome-tipo-usuario">
                    <span class="paragraph-regular">
                        {{ sessao?.nome }}
                    </span>
                    <span class="paragraph-regular">
                        {{ sessao?.admin ? 'Administrador' : 'Colaborador' }}
                    </span>
                </div>
            </div>
            <div class="container-btn-logout">
                <button
                    mat-button
                    (click)="logout()"
                    class="btn-logout">
                    <mat-icon [svgIcon]="'exit-to-app'"></mat-icon>
                    Sair
                </button>
            </div>
        </div>
    </div>

    <div class="contentSide" [ngStyle]="{'width': '100%'}">
        <router-outlet></router-outlet>

        <fab-buttons [fabButtons]="fabButtons" *ngIf="autenticado && showFabButton"></fab-buttons>
    </div>

    <div [ngClass]="['menu-filtro', filtro.open ? 'openfiltro' : '']" *ngIf="autenticado">
        <filtro [page]="filtro.page"></filtro>
    </div>

</div>
